import { SwitchersOptionsType } from '@/pages/bank/lesson-tasks/list/parts/modals/tasks-update/parts/switchers/types'

export const SWITCHERS_OPTIONS: SwitchersOptionsType = {
  archive: false,
  reserve: false,
}
